import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddUser';
import { useAuthValidation } from '../../utils/hooks';

const AddUserPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddUserPage;
